import { API, ENDPOINTS } from '@/app/services/api-url';
import EventBus from '@/app/eventBus';

class BillingApi {
  accountID;

  constructor(accountID) {
    this.accountID = accountID;
  }

  getSubscriptions() {
    return API.get(
      `${ENDPOINTS.GET_STRIPE_SUBSCRIPTION}?accountID=${this.accountID}`,
    )
      .then(res => res)
      .catch(() => {
        console.log('unable to load subscriptions, you probably don\'t have permissions');
      });
  }

  getPrices() {
    return API.get(
      `${ENDPOINTS.GET_APP_PRICES}?accountID=${this.accountID}&type=APP`,
    )
      .then((res) => {
        const products = res.data.products.map((product) => {
          const { app } = product.prices[0];
          return {
            app,
            ...product,
          };
        });
        res.data.products = products;
        return res;
      })
      .catch((err) => {
        EventBus.$emit('addNotification', {
          title: 'Loading Prices',
          icon: 'cross',
          message: err.message,
        });
      });
  }

  getPriceByProduct(product) {
    return API.get(
      `${ENDPOINTS.GET_APP_PRICES}?accountID=${
        this.accountID
      }&type=APP&appName=${product.toUpperCase()}`,
    )
      .catch((err) => {
        EventBus.$emit('addNotification', {
          title: 'Loading Prices',
          icon: 'cross',
          message: err.message,
        });
      });
  }
}

let billingApi = null;
let createBillingApi;

const useBillingApi = () => {
  if (!billingApi) {
    createBillingApi = (accountID) => {
      billingApi = new BillingApi(accountID);
      return billingApi;
    };
  }

  return billingApi || createBillingApi;
};

export default useBillingApi();
